import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

export function getDeliveryCompanies(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/delivery-companies", data || {})
}

export function getDeliveryPacks(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/order/delivery-packs", data || {})
}

export function postManualDeliver(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/manual-deliver", data || {})
}

export function postUpdateDelivery(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/update-delivery", data || {})
}

export function postCompensateDeliver(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/order/compensate-deliver", data || {})
}
